import React, { useEffect } from "react";

import IdleTimer from "react-idle-timer";

import { ToastContainer } from "react-toastify";

import Routes from "./routes";
import { UserContextProvider } from "./context/UserContext";
import { SidebarContextProvider } from "./context/SidebarContext";
import Theme from "./styles/Theme";
import api from "./services/api";
import "./styles/global.css";
import { GlobalVariables } from "./global";

const App = () => {
  api.setHeaders();

  useEffect(() => {
    if (
      window.location.host === "contadorvip.qyon.com" &&
      !window.location.href.includes("/integration/cardCode/")
    ) {
      window.location.assign(
        "https://contadorvip.qyon.com/integration/cardCode/input"
      );
    }
  }, []);

  const handleOnIdle = () => {
    const routeCurrent = window.location.href.split("/");

    if (!GlobalVariables.REDIRECT_BLOCK.includes(routeCurrent[3])) {
      window.location.assign(`${process.env.REACT_APP_WEB_PLUG}expiredToken`);
    }
  };

  return (
    <React.Fragment>
      <IdleTimer
        timeout={1000 * 60 * 25}
        onIdle={handleOnIdle}
        debounce={100}
      />
      <Theme>
        <UserContextProvider>
          <SidebarContextProvider>
            <Routes />
          </SidebarContextProvider>
        </UserContextProvider>
        <ToastContainer />
      </Theme>
    </React.Fragment>
  );
};

export default App;
